/* ============================================================================
   FW · Reveal — fades .fw-reveal elements in as they scroll into view.
   ----------------------------------------------------------------------------
   Re-runs on Shopify's section load events so the theme editor behaves.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '.fw-reveal:not(.is-visible)';
  var supported = 'IntersectionObserver' in window;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = supported && !reduced
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' })
    : null;

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll(SELECTOR);

    for (var i = 0; i < els.length; i++) {
      if (observer) observer.observe(els[i]);
      else els[i].classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(document); });
  } else {
    observe(document);
  }

  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', function (event) { observe(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target.closest ? event.target.closest('.fw-reveal') : null;
    if (el) el.classList.add('is-visible');
  });
})();
